import React from 'react'
import ItemsApp, { IItemModel } from './ItemsApp'
import { useDispatch } from 'react-redux'
import BasicDataViewer, { IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import AlertElement from '../../components/AlertElement'

interface IItemAdditionalDataProps {
    item: IItemModel,
    showAllDetails?: boolean,
    hideSectionBox?: boolean,
}

export default function ItemAdditionalData(props: IItemAdditionalDataProps) {

    const dispatch = useDispatch()

    const {
        item,
        showAllDetails,
        hideSectionBox,
    } = props

    const {
        additional_data
    } = item

    const itemsApp = new ItemsApp()

    if (Object.entries(additional_data).length === 0){
        return <></>
    }

    if (showAllDetails){
        if (additional_data){

            let detailsItems: IBasicDataViewItem[] = []

            Object.entries(itemsApp.deserializeItemAdditionalDataKeys(additional_data)).map(([key, value]) => {
                if (key === "fewer_details") return;

                detailsItems.push({
                    type: "text",
                    label: key,
                    value: String(value)
                })
            })

            return(
                <SectionBoxContainer title="Additional information" showTitle noWrap={hideSectionBox}>
                    {detailsItems.length > 0 ? <BasicDataViewer items={detailsItems} /> : <AlertElement type="error" message="No additional information has been provided" />}
                </SectionBoxContainer>
            )

        }
    }

    if ("fewer_details" in additional_data){
        return(
            <div className="additional-item-content-fewer-details">
                <div className="content-of-additional-item-content-fewer-details">
                    {Object.entries(itemsApp.deserializeItemAdditionalDataKeys(additional_data.fewer_details)).map(([key, value]) => {
                        if (!value){
                            return <></>
                        }

                        return(
                            <p key={key}>
                                <strong>{key}:</strong> {String(value)}
                            </p>
                        )
                    })}
                </div>
            </div>
        )
    }

    return <></>
}